import { useEffect } from "react";
import { Shield, Cookie, Mail } from "lucide-react";
import BackToTop from "../../components/BackToTop/BackToTop";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import HeroBg from "../../../src/images/hero-bg.png";


const Privacy = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-gradient-to-b from-gray-50 to-white">
            <BackToTop />

            {/* ================= HEADER ================= */}
            <Header />

            <div className="relative">

                <div className="absolute inset-0 w-full h-full">
                    <img
                        src={HeroBg}
                        loading="lazy"
                        sizes="(max-width: 1440px) 100vw, 1440px"
                        alt="hero"
                        className="w-full h-full object-cover"
                    />
                </div>

                {/* <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute top-0 -left-40 w-[400px] h-[400px] bg-gradient-to-r from-indigo-200/20 via-purple-200/20 to-pink-200/20 rounded-full blur-3xl animate-float-slow"></div>
                    <div className="absolute bottom-0 -right-40 w-[400px] h-[400px] bg-gradient-to-l from-pink-200/20 via-purple-200/20 to-indigo-200/20 rounded-full blur-3xl animate-float-slower"></div>

                    {[...Array(50)].map((_, i) => (
                        <div
                            key={i}
                            className="absolute w-1 h-1 bg-gradient-to-r from-indigo-400 to-purple-400 rounded-full animate-float-particle"
                            style={{
                                left: `${Math.random() * 100}%`,
                                top: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 8}s`,
                                animationDuration: `${15 + Math.random() * 15}s`,
                                opacity: 0.2,
                            }}
                        />
                    ))}
                </div> */}

                {/* Main Content */}
                <div className="max-w-6xl mx-auto px-6 py-20 relative">
                    {/* Hero Section */}
                    <div className="text-center mb-12 mt-12">
                        <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full mb-6">
                            <Shield className="h-4 w-4 text-indigo-600" />
                            <span className="text-sm font-medium text-indigo-600">Privacy First</span>
                        </div>
                        <h1 className="text-4xl md:text-5xl font-bold mb-4">
                            Privacy{" "}
                            <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                                Policy
                            </span>
                        </h1>
                        {/* <p className="text-gray-500 text-lg">Last updated: March 10, 2026</p> */}
                    </div>

                    {/* Privacy Highlights */}
                    {/* <div className="grid sm:grid-cols-3 gap-4 mb-8">
                    {[
                        { icon: Lock, title: "Your Data is Safe", desc: "256-bit encryption" },
                        { icon: Eye, title: "No Tracking", desc: "We respect your privacy" },
                        { icon: Database, title: "GDPR Compliant", desc: "EU data protection" },
                    ].map((item, i) => (
                        <div key={i} className="bg-white rounded-xl p-4 border border-gray-100 shadow-sm">
                            <item.icon className="h-5 w-5 text-indigo-600 mb-2" />
                            <h3 className="font-semibold text-sm">{item.title}</h3>
                            <p className="text-xs text-gray-500">{item.desc}</p>
                        </div>
                    ))}
                </div> */}

                    {/* Privacy Content */}
                    <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-gray-100 space-y-8">

                        {/* Introduction */}
                        <section>
                            <h2 className="text-2xl font-bold mb-4">Our Commitment to Privacy</h2>
                            <p className="text-gray-600 leading-relaxed">
                                At SocialTV, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose,
                                and safeguard your information when you use our platform. Please read this privacy policy carefully.
                                If you do not agree with the terms of this privacy policy, please do not access the site.
                            </p>
                        </section>

                        {/* Information Collection */}
                        <section>
                            <h2 className="text-2xl font-bold mb-4 flex items-center gap-3">
                                <span className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center text-indigo-600 text-lg">1</span>
                                Information We Collect
                            </h2>
                            <div className="pl-11 space-y-4">
                                <div>
                                    <h3 className="font-semibold text-gray-900 mb-2">Personal Data</h3>
                                    <p className="text-gray-600">We may collect personally identifiable information, such as:</p>
                                    <ul className="list-disc pl-5 mt-2 space-y-1 text-gray-600">
                                        <li>Name and email address when you create an account</li>
                                        <li>Billing information when you subscribe to paid plans</li>
                                        <li>Profile information you choose to provide</li>
                                        <li>Communications you send to us</li>
                                    </ul>
                                </div>

                                <div>
                                    <h3 className="font-semibold text-gray-900 mb-2">Usage Data</h3>
                                    <p className="text-gray-600">We automatically collect certain information when you visit our platform:</p>
                                    <ul className="list-disc pl-5 mt-2 space-y-1 text-gray-600">
                                        <li>IP address and browser type</li>
                                        <li>Pages visited and time spent</li>
                                        <li>Device information and operating system</li>
                                        <li>Referring website addresses</li>
                                    </ul>
                                </div>
                            </div>
                        </section>

                        {/* Cookies */}
                        <section>
                            <h2 className="text-2xl font-bold mb-4 flex items-center gap-3">
                                <span className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center text-indigo-600 text-lg">2</span>
                                Cookies and Tracking Technologies
                            </h2>
                            <div className="pl-11 space-y-4">
                                <p className="text-gray-600">
                                    We use cookies and similar tracking technologies to track activity on our platform and hold certain
                                    information. Cookies are files with small amount of data which may include an anonymous unique identifier.
                                </p>
                                <div className="bg-gray-50 p-4 rounded-xl">
                                    <h4 className="font-medium mb-2 flex items-center gap-2">
                                        <Cookie className="h-4 w-4 text-indigo-600" />
                                        Types of cookies we use:
                                    </h4>
                                    <ul className="list-disc pl-5 space-y-1 text-gray-600">
                                        <li><span className="font-medium">Essential cookies:</span> Required for platform operation</li>
                                        <li><span className="font-medium">Preference cookies:</span> Remember your settings</li>
                                        <li><span className="font-medium">Analytics cookies:</span> Help us improve our service</li>
                                    </ul>
                                </div>
                            </div>
                        </section>

                        {/* How We Use Information */}
                        <section>
                            <h2 className="text-2xl font-bold mb-4 flex items-center gap-3">
                                <span className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center text-indigo-600 text-lg">3</span>
                                How We Use Your Information
                            </h2>
                            <div className="pl-11">
                                <p className="text-gray-600 mb-3">We use the information we collect to:</p>
                                <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                    <li>Provide, operate, and maintain our platform</li>
                                    <li>Improve, personalize, and expand our services</li>
                                    <li>Process your transactions and manage your account</li>
                                    <li>Communicate with you about updates and offers</li>
                                    <li>Prevent fraudulent activity and enhance security</li>
                                    <li>Comply with legal obligations</li>
                                </ul>
                            </div>
                        </section>

                        {/* Data Sharing */}
                        <section>
                            <h2 className="text-2xl font-bold mb-4 flex items-center gap-3">
                                <span className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center text-indigo-600 text-lg">4</span>
                                Sharing Your Information
                            </h2>
                            <div className="pl-11 space-y-4">
                                <p className="text-gray-600">
                                    We do not sell, trade, or rent your personal information to third parties. We may share information in these situations:
                                </p>
                                <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                    <li><span className="font-medium">Service providers:</span> With vendors who help us operate our platform</li>
                                    <li><span className="font-medium">Legal requirements:</span> If required by law or to protect our rights</li>
                                    <li><span className="font-medium">Business transfers:</span> In connection with a merger or acquisition</li>
                                </ul>
                            </div>
                        </section>

                        {/* Data Security */}
                        <section>
                            <h2 className="text-2xl font-bold mb-4 flex items-center gap-3">
                                <span className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center text-indigo-600 text-lg">5</span>
                                Data Security
                            </h2>
                            <div className="pl-11">
                                <p className="text-gray-600 mb-3">
                                    We implement a variety of security measures to maintain the safety of your personal information:
                                </p>
                                <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                    <li>256-bit SSL encryption for all data transmission</li>
                                    <li>Regular security audits and penetration testing</li>
                                    <li>Strict access controls and authentication measures</li>
                                    <li>Secure data centers with 24/7 monitoring</li>
                                </ul>
                            </div>
                        </section>

                        {/* Your Rights */}
                        <section>
                            <h2 className="text-2xl font-bold mb-4 flex items-center gap-3">
                                <span className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center text-indigo-600 text-lg">6</span>
                                Your Privacy Rights
                            </h2>
                            <div className="pl-11">
                                <p className="text-gray-600 mb-3">Depending on your location, you may have the right to:</p>
                                <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                    <li>Access the personal information we hold about you</li>
                                    <li>Request correction of inaccurate information</li>
                                    <li>Request deletion of your information</li>
                                    <li>Object to processing of your information</li>
                                    <li>Request data portability</li>
                                    <li>Withdraw consent at any time</li>
                                </ul>
                            </div>
                        </section>

                        {/* Children's Privacy */}
                        <section>
                            <h2 className="text-2xl font-bold mb-4 flex items-center gap-3">
                                <span className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center text-indigo-600 text-lg">7</span>
                                Children's Privacy
                            </h2>
                            <div className="pl-11">
                                <p className="text-gray-600">
                                    Our platform is not intended for individuals under the age of 13. We do not knowingly collect personal
                                    information from children. If you become aware that a child has provided us with personal information,
                                    please contact us immediately.
                                </p>
                            </div>
                        </section>

                        {/* Changes to Policy */}
                        <section>
                            <h2 className="text-2xl font-bold mb-4 flex items-center gap-3">
                                <span className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center text-indigo-600 text-lg">8</span>
                                Changes to This Privacy Policy
                            </h2>
                            <div className="pl-11">
                                <p className="text-gray-600">
                                    We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new
                                    Privacy Policy on this page and updating the "Last updated" date. You are advised to review this Privacy
                                    Policy periodically for any changes.
                                </p>
                            </div>
                        </section>

                        {/* Contact Us */}
                        <section className="border-t border-gray-200 pt-8">
                            <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl p-8">
                                <h3 className="text-xl font-semibold mb-4">Questions About Your Privacy?</h3>
                                <p className="text-gray-600 mb-6">
                                    If you have any questions about this Privacy Policy, please contact our Data Protection Officer:
                                </p>
                                <div className="space-y-3">
                                    <div className="flex items-center gap-3">
                                        <Mail className="h-5 w-5 text-indigo-600" />
                                        <a href="mailto:privacy@socialtv.com" className="text-indigo-600 hover:underline">
                                            privacy@socialtv.com
                                        </a>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <Shield className="h-5 w-5 text-indigo-600" />
                                        <span className="text-gray-600">Data Protection Officer: dpo@socialtv.com</span>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>

            {/* ================= FOOTER ================= */}
            <Footer />
        </div>
    );
};

export default Privacy;